export function sanitizeHtml(str: string | undefined | null): string {
  if (str === undefined || str === null || str === '') return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .replace(/`/g, '&#96;');
}

export function escapeJsString(str: string | undefined | null): string {
  if (!str) return '';
  return String(str)
    .replace(/\\/g, '\\\\')
    .replace(/'/g, "\\'")
    .replace(/"/g, '\\"')
    .replace(/\n/g, '\\n')
    .replace(/\r/g, '\\r')
    .replace(/</g, '\\x3C');
}

export function safeId(str: string): string {
  return String(str).replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 100);
}

export function assertSafeId(str: string): string {
  if (!/^[a-zA-Z0-9_-]{1,100}$/.test(str)) {
    throw new Error('Unsafe ID');
  }
  return str;
}
